export function createPositionCode(parentCode = '', existingCodes = []) {
  if (!parentCode) return '';
  const used = new Set(existingCodes);
  let number = 1;
  let code;
  do { code = `${parentCode}-POS-${String(number++).padStart(3, '0')}`; } while (used.has(code));
  return code;
}

export function reparentPositionCode(code, oldParent, newParent, existingCodes = []) {
  if (!newParent) return '';
  const prefix = oldParent ? `${oldParent}-` : '';
  return prefix && code.startsWith(prefix)
    ? `${newParent}-${code.slice(prefix.length)}`
    : createPositionCode(newParent, existingCodes);
}
